document.addEventListener('DOMContentLoaded', function () {
  /* Announcement bar slider init */
  const sliderAnnouncementBar = document.querySelector(
    '#slider-announcement-bar'
  )
  if (sliderAnnouncementBar) {
    const splide = new Splide(sliderAnnouncementBar, {
      pagination: false,
      autoplay: true,
      type: 'loop',
      width: '100%',
    })
    splide.mount()
  }

  /* Remove announcement bar per session */
  const barCheck = () => {
    var hidebar = sessionStorage.getItem('bar-hide') || false
    if (hidebar) {
      barHide()
    }
  }

  const barEvents = () => {
    const dismissTrigger = document.querySelector('.dismiss')
    if (dismissTrigger) {
      dismissTrigger.addEventListener('click', function (e) {
        e.preventDefault()

        barPrevent()
        barHide()
      })
    }
  }

  const barHide = () => {
    document.querySelector('#shopify-section-announcement-bar').remove()

    setTimeout(() => {
      document.querySelector('hh-sticky-header').setSpacerHeight()
    }, 100)
  }
  const barPrevent = () => {
    sessionStorage.setItem('bar-hide', true)
  }

  barCheck()
  barEvents()
})
